import _styled from "@emotion/styled-base";
import { fade } from '@swp/colors';
import layout from './layout';
export var Name = _styled("label", {
  target: "ezp5wk40"
})({
  name: "zuwdt7",
  styles: "display:none;color:var(--color-main-1);font:inherit;"
});
var baseInput = "\n\tborder-color: currentColor;\n\tborder-style: solid;\n\tborder-width: 0;\n\tborder-bottom-width: 1px;\n\tbox-sizing: border-box;\n\tcolor: var(--color-main-1);\n\tdisplay: inline-block;\n\tfont: inherit;\n\twidth: 100%;\n";
export var Input = _styled("input", {
  target: "ezp5wk41"
})(baseInput, " background-color:transparent;height:2em;padding:0.4em 0.2em;");
export var BtnBox = _styled("label", {
  target: "ezp5wk42"
})({
  name: "xvm4ky",
  styles: "font-size:1.1875rem;"
});
export var Btn = _styled("button", {
  target: "ezp5wk43"
})();
export var TextareaPoint = _styled("div", {
  target: "ezp5wk44"
})({
  name: "1sn72ru",
  styles: "padding-bottom:1.3em;"
});
export var Textarea = _styled("textarea", {
  target: "ezp5wk45"
})(baseInput, " background-color:", function (props) {
  return fade(props.theme.colors.back2, 0.02);
}, ";height:150px;padding:0.4em;");
export var Point = _styled("div", {
  target: "ezp5wk46"
})({
  name: "1sn72ru",
  styles: "padding-bottom:1.3em;"
});
export var StyledForm = _styled("form", {
  target: "ezp5wk47"
})("width:100%;overflow:hidden;max-width:900px;margin:auto;font-family:var(--font1);font-size:1.5rem;line-height:1.0833;", function (props) {
  return props.layout && layout[props.layout] ? layout[props.layout](props.theme) : '';
}, " .contact-form__name{display:none;}.no-placeholder .contact-form__name{font-size:24px;line-height:26px;color:var(--color-main-1);display:block;}&.--invert{.no-placeholder .contact-form__name{color:var(--color-main-2);}", Name, ",", Input, ",", Textarea, "{color:var(--color-main-2);}", Input, ",", Textarea, "{border-width:1px;}", Input, ",", Textarea, "{::placeholder{color:var(--color-main-2);}::-webkit-input-placeholder{color:var(--color-main-2);}::-moz-placeholder{color:var(--color-main-2);}:-ms-input-placeholder{color:var(--color-main-2);}}}");